module.exports = __webpack_public_path__ + "static/media/denver_team.84fd96c2.jpg";